"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getForwardedByYouMessage = exports.getForwardedToYouMessage = exports.isReassignedToSelf = exports.approvalStatusToLabel = exports.isProcessing = void 0;
exports.filterActivitiesByUserFilters = filterActivitiesByUserFilters;
exports.filterApprovalsByTabAndSearch = filterApprovalsByTabAndSearch;
exports.sortApprovals = sortApprovals;
exports.getEmptyMessage = getEmptyMessage;
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const lodash_1 = __importDefault(require("lodash"));
const dateUtils_1 = require("../../../utils/dateUtils");
const translationUtil_1 = require("../../../utils/translationUtil");
const slices_1 = require("../../../zustandStore/slices");
const lexico = new lexico_1.default();
const isProcessing = (approval) => {
    if (lodash_1.default.isString(approval?.context?.isProcessing)) {
        return approval?.context?.isProcessing === 'true';
    }
    return approval?.context?.isProcessing;
};
exports.isProcessing = isProcessing;
exports.approvalStatusToLabel = {
    approved: 'Approved',
    'card-canceled': `Card ${(0, translationUtil_1.getCancelledWord)('canceled')}`,
    canceled: `Card ${(0, translationUtil_1.getCancelledWord)('canceled')}`,
    declined: 'Declined',
    'forwarded-pending': 'Forwarded (pending)',
    pending: 'Pending',
    'pending-forwarded': 'Pending (forwarded)',
};
const isReassignedToSelf = (approval) => {
    if (lodash_1.default.isString(approval.context.reassignedToSelf)) {
        return approval.context.reassignedToSelf === 'true';
    }
    return approval.context.reassignedToSelf;
};
exports.isReassignedToSelf = isReassignedToSelf;
const getForwardedToYouMessage = (approval, currentUser) => {
    const assignedOn = (0, dateUtils_1.formatDate)(approval.assignedOn, currentUser?.language);
    if ((0, exports.isReassignedToSelf)(approval)) {
        return `This request was re-assigned to you on ${assignedOn}.`;
    }
    return approval.outcome === 'SELF-REASSIGNED'
        ? 'This request has been reassigned.'
        : `${approval.reassignedByUser?.fullName} forwarded this request to you on ${assignedOn}.`;
};
exports.getForwardedToYouMessage = getForwardedToYouMessage;
const getForwardedByYouMessage = (approval, currentUser) => {
    if (!approval.completedOn) {
        return '';
    }
    const completedOn = (0, dateUtils_1.formatDate)(approval.completedOn, currentUser?.language);
    return approval.context.isAutoForwarded === 'true'
        ? `This request was automatically forwarded to ${approval.reassignedToUser?.fullName} on ${completedOn}.`
        : `You forwarded this request to ${approval.reassignedToUser?.fullName} on ${completedOn}.`;
};
exports.getForwardedByYouMessage = getForwardedByYouMessage;
function getComparableValue(approval, sortKey) {
    switch (sortKey) {
        case 'mostRecent': {
            return new Date(approval.request.lastEdit);
        }
        case 'requester': {
            return approval.request.requester.firstName.toLowerCase();
        }
        case 'lowToHigh':
        case 'highToLow': {
            return approval.request.amount;
        }
        default: {
            return approval;
        }
    }
}
function filterActivitiesByUserFilters(approvals, filters) {
    return approvals
        ?.filter(approval => filters.team === 'all' || (filters.team !== 'all' && approval.request.teamId === filters.team))
        ?.filter(approval => filters.member === 'all' || (filters.member !== 'all' && approval.assigner === filters.member));
}
function filterApprovalsByTabAndSearch(approvals, searchValue) {
    const searchLower = searchValue.toLowerCase();
    return approvals?.filter(approval => approval.request.title.toLowerCase().includes(searchLower));
}
function sortApprovals(approvals, sortValue) {
    if (!sortValue) {
        return approvals;
    }
    const [sortKey = 'mostRecent'] = Object.keys(sortValue);
    const sortOrder = slices_1.sortApprovalsOptions[sortKey];
    return approvals?.sort((a, b) => {
        const valueA = getComparableValue(a, sortKey);
        const valueB = getComparableValue(b, sortKey);
        if (sortOrder === 'asc') {
            return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
        }
        else {
            return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
        }
    });
}
function getEmptyMessage(approvalState) {
    switch (approvalState) {
        case 'pending': {
            return lexico.trc('Empty data table message', 'You have no pending approvals.');
        }
        case 'approved': {
            return lexico.trc('Empty data table message', 'You have no approved approvals.');
        }
        case 'declined': {
            return lexico.trc('Empty data table message', 'You have no declined approvals.');
        }
        case 'canceled': {
            return lexico.trc('Empty data table message', `You have no ${(0, translationUtil_1.getCancelledWord)('canceled')} approvals.`);
        }
        default: {
            return lexico.trc('Empty data table message', 'You have no approvals.');
        }
    }
}
